var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user === 'client')?_c('div',[_c('client-settings-nav-component'),_vm._v(" "),_c('router-view')],1):_c('div')}
var staticRenderFns = []

export { render, staticRenderFns }